import { Component, inject, input, InputSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';

import { environment } from '../../../../environments/environment';

import { UserMessagesEnum } from '@utilities/enums/user-message.enum';

import { MainNavigationService } from '@services/main-nav/main-nav.service';

import { AccountSettingsComponent } from '../account-settings/account-settings.component';

import { SnackBar } from '@utilities/toast-options';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [FormsModule, AccountSettingsComponent],
})
export class HeaderComponent {
  isNavExpanded: InputSignal<boolean> = input<boolean>(false);

  public readonly year = new Date().getFullYear().toString();

  newBaseUrl = sessionStorage.getItem('newBaseUrl') || environment.baseUrl;
  canSwapBaseUrl = environment.canSwapBaseUrl;

  private readonly userMessages: typeof UserMessagesEnum = UserMessagesEnum;

  private mainNavService = inject(MainNavigationService);
  private snackBar = inject(MatSnackBar);
  firstName: string = '';
  lastName: string = '';

  private authService = inject(AuthService);
  
  ngOnInit(): void {
    this.firstName = this.authService.getFirstName();
    this.lastName = this.authService.getLastName();
  }

  onResetEnvClick(): void {
    sessionStorage.removeItem('newBaseUrl');
    this.newBaseUrl = environment.baseUrl;
    this.snackBar.open(
      this.userMessages.BaseUrlIsRestored,
      'Close',
      SnackBar.getOptions('success')
    );
  }

  onSwapEnvClick(): void {
    if (!this.newBaseUrl.endsWith('/')) {
      this.newBaseUrl = this.newBaseUrl + '/';
    } else {
      this.newBaseUrl = this.newBaseUrl.replace(/\/+$/, '/');
    }

    sessionStorage.setItem('newBaseUrl', this.newBaseUrl);
    this.snackBar.open(this.userMessages.BaseUrlIsSetup, 'Close', SnackBar.getOptions('success'));
  }

  public changeNavState(isOpen: boolean): void {
    this.mainNavService.setMainNavState(isOpen);
  }
}
